import React from 'react';
import { StTagInfo } from './Tag.style';

interface StatusTagsProps {
  tag: string;
  fontSize?: string;
  fontWeight?: string;
  index: number;
  color: string;
}

const Tag: React.FC<StatusTagsProps> = ({ color, index, tag, fontSize, fontWeight }) => {
  return (
    <StTagInfo
      id="SearchTags"
      item
      key={`${tag}-${index}`}
      sx={{
        background: color,
        fontSize,
        fontWeight,
      }}
    >
      {tag}
    </StTagInfo>
  );
};

export default Tag;
